import React, { useCallback, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import FilterButtons from "./components/FilterButtons";
import { serviceService } from "../../../services/api/serviceService";
import { AuthContext } from "../../../contexts/AuthContext";
import { toast } from "react-toastify";
import Loading from "../components/Loading";
import Button from "../components/Button";

const formatCategory = (arr) =>
  (arr || []).map((item) => ({
    id: item.id,
    name: item.name,
    image: item.image,
  }));

const ListService = () => {
  const { token_client } = useContext(AuthContext);
  const [categoryList, setCategoryList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const fetchCategories = useCallback(async () => {
    try {
      setErr("");
      setLoading(true);
      const res = await serviceService.get_all_category(token_client);
      const categories = formatCategory(res?.categories);
      setCategoryList(categories);
    } catch (e) {
      toast.dismiss();
      setErr("Không thể tải danh mục. Vui lòng thử lại.");
      toast.error("Lỗi khi lấy danh mục");
    } finally {
      setLoading(false);
    }
  }, [token_client]);

  useEffect(() => {
    fetchCategories();
  }, [fetchCategories]);

  const navigate = useNavigate();
  const handleSelectCategory = useCallback(
    (cat) => navigate(`/danh-sach-dich-vu/${cat.id}`),
    [navigate],
  );

  return (
    <div className="mx-auto flex flex-col w-full items-center gap-8 py-6">
      <div className="w-full">
        {loading ? (
          <div className="flex justify-center py-10">
            <Loading />
          </div>
        ) : err ? (
          <div className="flex flex-col items-center gap-3 py-10">
            <img
              src="/images/empty.png"
              alt="Lỗi tải dữ liệu"
              className="size-25 opacity-70"
              loading="lazy"
            />
            <p className="text-sm text-gray-600">{err}</p>
            <Button
              type="button"
              variant="primary"
              size="lg"
              onClick={fetchCategories}
            >
              Thử lại
            </Button>
          </div>
        ) : categoryList.length === 0 ? (
          <div className="flex flex-col items-center gap-3 py-10">
            <img
              src="/images/empty.png"
              alt="Không có dữ liệu"
              className="size-25 opacity-70"
              loading="lazy"
            />
            <p className="text-sm text-gray-600">Chưa có danh mục dịch vụ.</p>
          </div>
        ) : (
          <FilterButtons
            category={categoryList}
            onSelect={handleSelectCategory}
          />
        )}
      </div>
    </div>
  );
};

export default ListService;
